import React from "react";
import { CircleCheck, CircleX, Ear, ClipboardCheck, MessageCircle, ShieldX, Scale, Hand } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const coreFunctions = [{
  title: "Identifikationsdaten",
  description: "Wir erfassen grundlegende Informationen wie Ihren vollständigen Namen und Ihre E-Mail-Adresse zur Kommunikation.",
  icon: Ear
}, {
  title: "Technische Protokolle",
  description: "Ihre IP-Adresse und Browsertyp werden automatisch protokolliert, um die Sicherheit und Stabilität der Website zu gewährleisten.",
  icon: ClipboardCheck
}];
const boundaries = [{
  title: "Keine sensiblen Daten",
  description: "Wir fordern niemals Informationen über Ihre Gesundheit, Religion oder politische Gesinnung über Standardformulare an.",
  icon: ShieldX
}, {
  title: "Kein Datenverkauf",
  description: "Ihre persönlichen Informationen werden unter keinen Umständen an Dritte für Marketingzwecke verkauft oder vermietet.",
  icon: Scale
}, {
  title: "Eingeschränkter Zugriff",
  description: "Nur autorisiertes Personal mit strikten Geheimhaltungspflichten hat Zugriff auf die von uns gespeicherten Datensätze.",
  icon: Hand
}];
export default function Datenerhebung() {
  return <section data-section-id="252314" id="datenerhebung" className="py-24 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-6 tracking-tight">
            Transparente Datenerhebung
          </h2>
          <p className="text-lg text-muted-foreground font-default leading-relaxed">
            Der Schutz Ihrer Privatsphäre hat für uns oberste Priorität. Hier erfahren Sie genau, welche Informationen wir erfassen und wo wir klare Grenzen ziehen.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {}
          <Card className="border-primary/20 shadow-lg bg-card h-full">
            <CardHeader className="pb-8">
              <div className="flex items-center gap-3 mb-2">
                <CircleCheck className="size-6 text-primary" aria-hidden="true" />
                <CardTitle className="text-2xl font-default text-primary">
                  Erfasste Informationen
                </CardTitle>
              </div>
              <p className="text-muted-foreground font-default">
                Diese Daten benötigen wir für einen reibungslosen Service.
              </p>
            </CardHeader>
            <CardContent className="flex flex-col gap-8">
              {coreFunctions.map((item, i) => <div data-index={i} key={i} className="flex gap-4">
                  <div className="shrink-0 mt-1">
                    <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary">
                      <item.icon className="size-5" aria-hidden="true" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold font-default text-foreground mb-2">
                      {item.title}
                    </h3>
                    <p className="text-muted-foreground font-default leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </CardContent>
          </Card>

          {}
          <Card className="border-border shadow-md bg-secondary/20 h-full">
            <CardHeader className="pb-8">
              <div className="flex items-center gap-3 mb-2">
                <CircleX className="size-6 text-muted-foreground" aria-hidden="true" />
                <CardTitle className="text-2xl font-default text-primary">
                  Ausschlüsse & Schutz
                </CardTitle>
              </div>
              <p className="text-muted-foreground font-default">
                Was wir bewusst nicht tun und wie wir Ihre Daten schützen.
              </p>
            </CardHeader>
            <CardContent className="flex flex-col gap-8">
              {boundaries.map((item, i) => <div data-index={i} key={i} className="flex gap-4">
                  <div className="shrink-0 mt-1">
                    <div className="flex items-center justify-center size-10 rounded-lg bg-background border border-border text-muted-foreground shadow-sm">
                      <item.icon className="size-5" aria-hidden="true" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold font-default text-foreground mb-2">
                      {item.title}
                    </h3>
                    <p className="text-muted-foreground font-default leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}